import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const UnsubscribeConfirmationLandingPage = lazy(
  () =>
    import(
      '@aboutyou/logic-components/src/backend-services/NewsletterSubscription/UnsubscribeConfirmationLandingPage'
    ).then(mod => ({default: mod.UnsubscribeConfirmationLandingPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
